import type { PaginationMeta } from '@core/http-types';

export const isAllPagesLoaded = (pagination: PaginationMeta) =>
  pagination.totalCount <= pagination.page * pagination.limit;
